import { FC } from 'react';

interface TagProps {
  count: number;
}

const Tag: FC<TagProps> = ({ count }) => {
  const isMultiDigit = count > 9;
  const fontSize = isMultiDigit ? 7 : 8;

  return (
    <div className="relative inline-flex items-center cursor-pointer">
      <svg
        width="29"
        height="29"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Base Icon */}
        <path
          d="M5.1318 13.1055L5.6681 7.44178C5.69527 7.14827 5.929 6.91636 6.22251 6.88737L11.8862 6.35107H11.8935C11.9514 6.35107 11.9967 6.36919 12.0312 6.40362L20.5159 14.8883C20.5327 14.9051 20.546 14.925 20.5551 14.9469C20.5642 14.9688 20.5688 14.9923 20.5688 15.016C20.5688 15.0398 20.5642 15.0633 20.5551 15.0852C20.546 15.1071 20.5327 15.127 20.5159 15.1438L13.9245 21.7351C13.8901 21.7696 13.8448 21.7877 13.7959 21.7877C13.7469 21.7877 13.7017 21.7696 13.6672 21.7351L5.18253 13.2504C5.1463 13.2124 5.12818 13.1598 5.1318 13.1055ZM13.7977 19.9161L18.6968 15.017L11.455 7.77516L6.97985 8.19912L6.55588 12.6743L13.7977 19.9161ZM9.80627 9.43115C10.685 9.43115 11.4007 10.1468 11.4007 11.0255C11.4007 11.9043 10.685 12.6199 9.80627 12.6199C8.92754 12.6199 8.21188 11.9043 8.21188 11.0255C8.21188 10.1468 8.92754 9.43115 9.80627 9.43115ZM9.80627 11.6053C10.127 11.6053 10.386 11.3462 10.386 11.0255C10.386 10.7048 10.127 10.4458 9.80627 10.4458C9.48558 10.4458 9.22649 10.7048 9.22649 11.0255C9.22649 11.3462 9.48558 11.6053 9.80627 11.6053Z"
          fill="#191915"
        />

        {/* Badge + Count */}
        {count > 0 && (
          <>
            {/* Badge background */}
            <rect
              x="10.8"
              y="0.8"
              width="12.5"
              height="13"
              rx="6.25"
              fill="#0C0B02"
            />
            <rect
              x="10.8"
              y="0.8"
              width="12.5"
              height="13"
              rx="6.25"
              stroke="white"
              strokeWidth="1.2"
            />

            {/* Count text */}
            <text
              x="17.05" // horizontal center of badge
              y="7.3" // vertical midpoint
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize={fontSize}
              fill="white"
              fontFamily="Arial, sans-serif"
              fontWeight="bold"
            >
              {count}
            </text>
          </>
        )}
      </svg>
    </div>
  );
};

export default Tag;
